// extracted by css-extract-rspack-plugin
export default {"header":"browse-module__header___BJplp","topAd":"browse-module__topAd___TiUKj","containerItems":"browse-module__containerItems___FTLj6"};